
// Notice: unfortunately, JS code is injected only inside local HTML
export const injectedScript = (uniqueID: string) => 
  /* js */`
    window.uniqueID = "${uniqueID}";

    window._postMessage = (message) => {
        message = JSON.stringify(message);
        if(window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(message);
        } else {
            window.parent.postMessage(message, "*");
        }
    };

    const __resize__ = async function() {
        const body = document.body;
        const {width, height} = body.getBoundingClientRect();
        // Build the message to post to RN codebase
        const data = {};
        data[uniqueID] = {
            width,
            height,
        };
        // UPDATE THE WEBVIEW PROPS / DATA TO REACT-NATIVE
        window._postMessage(data);
    };

    const __pdf__ = async function() {
      // Construct PDF data URI
      if (html2pdf) {
        const pdfDataURI = await html2pdf()
                .from(document.body)
                .to('pdf')
                .set({
                    margin: 0,
                    image: { type: 'jpeg', quality: 1 },
                    html2canvas: { scale: 2, logging: true, dpi: 300 },
                    jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
                })
                .outputPdf('dataurlstring');
        
        // Build the message to post to RN codebase
        const data = {};
        data[uniqueID] = { pdfDataURI };
        
        // UPDATE THE WEBVIEW PROPS / DATA TO REACT-NATIVE
        window._postMessage(data);
      }
    };

    // debugger;
    
    // Resize the webview to match the page (document) dimension
    try {
      __resize__();
    } catch (error) {
      console.log(error);
    }
    
    // Create a PDF copy of the web page
    try {
      __pdf__();
    } catch (error) {
      console.log(error);
    }

    true;
`;

export default injectedScript;